import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: true },
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
    },
    {
        path: '/auth/callback',
        name: 'OAuth2Callback',
        component: () => import(/* webpackChunkName: "auth" */ '../views/OAuth2Callback.vue'),
        props: true,
    },
    {
        path: '/documents',
        name: 'Documents',
        component: () => import(/* webpackChunkName: "documents" */ '../views/Documents.vue'),
        props: true,
        meta: { requiresAuth: true },
    },
    {
        path: '/multi-upload',
        name: 'MultiUpload',
        component: () => import(/* webpackChunkName: "multi-upload" */ '../views/MultiUpload.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/tags',
        name: 'Tags',
        component: () => import(/* webpackChunkName: "tags" */ '../views/Tags.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/trash',
        name: 'Trash',
        component: () => import(/* webpackChunkName: "documents" */ '../views/Trash.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/statistics',
        name: 'Statistics',
        component: () => import(/* webpackChunkName: "statistics" */ '../views/Statistics.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/password-reset',
        name: 'PasswordReset',
        component: () => import(/* webpackChunkName: "password-reset" */ '../views/PasswordReset.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/settings',
        name: 'Settings',
        component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
        meta: { requiresAuth: true },
    },
]

const router = new VueRouter({
    routes,
})

router.beforeEach((to, from, next) => {
    if (to.name === 'OAuth2Callback' && !localStorage.getItem('nhb_bonbon_at')) {
        next()
        return
    }

    if (to.meta?.requiresAuth && !localStorage.getItem('nhb_bonbon_at')) {
        next('login')
    }

    if (['Login', 'OAuth2Callback'].includes(to.name) && localStorage.getItem('nhb_bonbon_at')) {
        next('/')
    }

    next()
})

export default router
